
import { Options } from "vue-class-component";
import { FormGroup } from "../../../model/FormGroup.model";
import BaseForm from "../../baseForm/baseForm.vue";
@Options({})
export default class NumberQuestion extends BaseForm {
  public numberQuestion = 10;
  public formGroup: FormGroup = {
    numberQuestion: {
      rules: [],
      value: this.numberQuestion
    }
  };
}
